    <div class="aktivasyon-ekran">
      <div class="bg-grid"></div>
      <div class="bg-glow"></div>

      <!-- Logo -->
      <div class="logo-alani">
        <div class="logo-cerceve"><span class="logo-ikon">📟</span></div>
        <h1 class="marka">FikoYT</h1>
        <p class="alt-baslik">Endüstriyel IoT Sistemi</p>
      </div>

      <!-- ═══ HOŞGELDİNİZ ═══ -->
      @if (asama() === 'hosgeldiniz') {
        <div class="kart hosgeldiniz-kart">
          <div class="hg-baslik">
            <h2>HMI Saha Ekranı</h2>
            <p>Bu ekranı fabrika veya üretim alanındaki bilgi paneli olarak kullanabilirsiniz</p>
          </div>
          <div class="hg-ozellikler">
            <div class="hg-ozellik">
              <span class="hg-ikon">🪪</span>
              <div class="hg-ozellik-icerik"><strong>Kart Okuyucu</strong><span>NFC/RFID ile personel giriş-çıkış takibi</span></div>
            </div>
            <div class="hg-ozellik">
              <span class="hg-ikon">📊</span>
              <div class="hg-ozellik-icerik"><strong>Canlı Göstergeler</strong><span>Üretim verileri, istatistikler ve duyurular</span></div>
            </div>
            <div class="hg-ozellik">
              <span class="hg-ikon">🏭</span>
              <div class="hg-ozellik-icerik"><strong>Firma Entegrasyonu</strong><span>Firmanıza özel logo, tema ve yapılandırma</span></div>
            </div>
            <div class="hg-ozellik">
              <span class="hg-ikon">🔒</span>
              <div class="hg-ozellik-icerik"><strong>Güvenli Bağlantı</strong><span>Yönetici onayı ile cihaz eşleştirme</span></div>
            </div>
          </div>
          <button class="kurulum-btn" (click)="cihazKaydet()">
            <span class="kurulum-btn-ikon">⚙️</span>
            Bu cihazı HMI saha ekranı olarak ayarla
          </button>
          <button class="geri-btn" style="margin-bottom:8px" (click)="asama.set('kod-girisi')">
            🔑 Aktivasyon kodum var
          </button>
          <button class="geri-btn" (click)="geriDon()">← Ana sayfaya dön</button>
        </div>
      }

      <!-- ═══ KAYDEDİLİYOR ═══ -->
      @if (asama() === 'kaydediliyor') {
        <div class="kart">
          <div class="yukleme-alani">
            <div class="spinner"></div>
            <h2>Cihaz Kaydediliyor...</h2>
            <p>Sisteme kayıt oluşturuluyor</p>
          </div>
        </div>
      }

      <!-- ═══ AKTİVASYON BEKLİYOR ═══ -->
      @if (asama() === 'aktivasyon-bekliyor') {
        <div class="kart bekliyor-kart">
          <div class="bekliyor-alani">
            <div class="bekliyor-ikon-wrap">
              <div class="bekliyor-pulse"></div>
              <span class="bekliyor-ikon">⏳</span>
            </div>
            <h2>Yönetici Onayı Bekleniyor</h2>
            <p class="bekliyor-aciklama">Bu cihaz sisteme kaydedildi. Yöneticinizin admin panelinden bu cihazı bir firmaya ataması ve aktifleştirmesi gerekiyor.</p>

            <div class="cihaz-kimlik-kutu">
              <div class="ck-etiket">Cihaz Kimliği</div>
              <div class="ck-deger">{{ cihazKimlik }}</div>
            </div>

            <div class="durum-bar">
              <div class="durum-adim tamamlandi">
                <div class="durum-nokta">✓</div>
                <span>Kayıt</span>
              </div>
              <div class="durum-cizgi"></div>
              <div class="durum-adim bekliyor">
                <div class="durum-nokta aktif">
                  <div class="durum-nokta-pulse"></div>
                </div>
                <span>Onay</span>
              </div>
              <div class="durum-cizgi"></div>
              <div class="durum-adim">
                <div class="durum-nokta">3</div>
                <span>Aktif</span>
              </div>
            </div>

            <div class="polling-bilgi">
              <div class="polling-dot"></div>
              Canlı takip ediliyorr...
            </div>

            <button class="iptal-btn" (click)="kaydiIptalEt()">Kaydı İptal Et</button>
          </div>
        </div>
      }

      <!-- ═══ KOD GİRİŞ ═══ -->
      @if (asama() === 'kod-girisi') {
        <div class="kart">
          <div class="kart-baslik">
            <span class="kart-ikon">🔑</span>
            <h2>Aktivasyon Kodu</h2>
            <p>Yöneticinizden aldığınız 6 haneli kodu giriniz</p>
          </div>
          <div class="kod-alani">
            @for (i of [0,1,2,3,4,5]; track i) {
              <input class="kod-input" [class.dolu]="kodHaneler[i]" [class.aktif]="aktifHane() === i"
                maxlength="1" (input)="haneGirildi($event, i)" (keydown)="tusKontrol($event, i)"
                (focus)="aktifHane.set(i)" (paste)="yapistir($event)" [value]="kodHaneler[i]"
                #haneInput autocomplete="off" inputmode="text" />
            }
          </div>
          @if (hataMesaji()) {
            <div class="hata-mesaj"><span>⚠️</span> {{ hataMesaji() }}</div>
          }
          <button class="aktive-btn" [disabled]="kodTam() === false" (click)="kodDogrula()">Aktive Et</button>
          <div class="cihaz-bilgi">
            <span class="bilgi-ikon">💻</span>
            <span>Cihaz: <code>{{ cihazKimlik }}</code></span>
          </div>
          <button class="geri-link" (click)="asama.set('hosgeldiniz')">← Geri</button>
        </div>
      }

      <!-- ═══ DOĞRULANIYOR ═══ -->
      @if (asama() === 'dogrulaniyor') {
        <div class="kart">
          <div class="yukleme-alani">
            <div class="spinner"></div>
            <h2>Doğrulanıyor...</h2>
            <p>Aktivasyon kodu kontrol ediliyor</p>
          </div>
        </div>
      }

      <!-- ═══ BAŞARILI ═══ -->
      @if (asama() === 'basarili') {
        <div class="kart basarili-kart">
          <div class="basarili-alani">
            <div class="basarili-ikon-wrap"><span class="basarili-ikon">✅</span></div>
            <h2>Aktivasyon Başarılı!</h2>
            <p class="firma-adi">{{ aktivFirmaAdi() }}</p>
            <div class="bilgi-satirlari">
              <div class="bilgi-satir"><span class="bs-etiket">Cihaz Adı</span><span class="bs-deger">{{ aktivCihazAdi() }}</span></div>
              <div class="bilgi-satir"><span class="bs-etiket">Uygulama Modu</span><span class="bs-deger mod-badge">{{ aktivMod() }}</span></div>
              <div class="bilgi-satir"><span class="bs-etiket">Konum</span><span class="bs-deger">{{ aktivKonum() || '-' }}</span></div>
            </div>
            <div class="geri-sayim"><span>{{ geriSayim() }}</span> saniye içinde yönlendiriliyorsunuz...</div>
          </div>
        </div>
      }

      <!-- ═══ HATA ═══ -->
      @if (asama() === 'hata') {
        <div class="kart hata-kart">
          <div class="hata-alani">
            <span class="hata-ikon">❌</span>
            <h2>İşlem Başarısız</h2>
            <p>{{ hataMesaji() || 'Geçersiz veya süresi dolmuş kod' }}</p>
            <button class="tekrar-btn" (click)="sifirla()">Tekrar Dene</button>
          </div>
        </div>
      }

      <div class="alt-bilgi">
        <span>FikoYT Endüstriyel IoT Platform</span>
        <span class="separator">•</span>
        <span>v2.0</span>
      </div>
    </div>
